// oxlint-disable explicit-function-return-type, explicit-module-boundary-types

import { createRouter } from "@tanstack/react-router";

import { routeTree } from "./routeTree.gen";

const router = createRouter({ routeTree, defaultPreload: "viewport" });

const getRouter = () => router;

declare module "@tanstack/react-router" {
	interface Register {
		router: ReturnType<typeof getRouter>;
	}
}

export { getRouter };
